import { FETCH_SEARCH_SERVICE, CLEAR_SEARCH_SERVICE } from '../actions/SearchServiceAction';

const initialState = {
  stations: []
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_SEARCH_SERVICE:
      return [
        ...action.payload
      ]
    case CLEAR_SEARCH_SERVICE:
      return [
        ...initialState
      ]
    default:
      return [
        ...state
      ]
  }
}


// WEBPACK FOOTER //
// ./src/reducers/SearchServiceReducer.js